/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IntervalTypeEnum = 'Monthly' | 'Yearly' | 'Daily' | 'Quarterly' | 'Annually';

export const IntervalTypeEnum = {
    Monthly: 'Monthly' as IntervalTypeEnum,
    Yearly: 'Yearly' as IntervalTypeEnum,
    Daily: 'Daily' as IntervalTypeEnum,
    Quarterly: 'Quarterly' as IntervalTypeEnum,
    Annually: 'Annually' as IntervalTypeEnum
};

